import { Menu } from '../menu'
import { Footer } from '../footer'
import { Legal } from '../legal'
import { MenuHandler } from '../menu-handler'

function initializeModules(currentLanguage) {
  Menu.mount(currentLanguage)
  Footer.mount(currentLanguage)
  Legal.mount(currentLanguage)
  MenuHandler.init()
}

export { initializeModules }
